import { useTranslation } from "react-i18next";
import OrderModal, {
  ModalType,
} from "../../../../../../../components/OrderModal/OrderModal";

const ResetOrderModal = ({
  open,
  closeModal,
  primaryButtonClick,
}: ModalType) => {
  const { t } = useTranslation(["orders", "common"]);
  return (
    <>
      <OrderModal
        data-testid="reset-order-modal"
        openModal={open}
        title={t("orders:modal.resetOrderModal.title")}
        description={t("orders:modal.resetOrderModal.description")}
        primaryButtonName={t("common:button.reset")}
        secondaryButtonName={t("common:modal.cancelBtn")}
        closeModalFn={closeModal}
        onPrimaryButtonClick={primaryButtonClick}
      />
    </>
  );
};

export default ResetOrderModal;
